
import { url } from "./config/config";
import { PROVIDER_LOGIN, CLIENT_LOGIN, CORPORATE_LOGIN  } from "./app/constant/userType";

function safeParseSession(userType) {
    try {
        const session = getObject(userType);
        return session ? JSON.parse(session) : {};
    } catch (error) {
        return {};
    }
}

function hasValidSession(session) {
    return session && Object.keys(session).length > 0 && session.token;
}

export function isLoggedIn(userType) {

    let session = safeParseSession(userType)
    let accessToken = (session && session['token']) || false;
    return accessToken;
}

export function isProviderLoggedIn(userType) {

    let session = safeParseSession(userType)
    let accessToken = (session && session['token']) || false;
    return accessToken;
}

export function isCorporateLoggedIn(userType) {

    let session = safeParseSession(userType)
    let accessToken = (session && session['token']) || false;
    return accessToken;
}

export function isCommonLoggedIn() {
    let userType = CLIENT_LOGIN;
    let session = safeParseSession(userType)
    if(hasValidSession(session)) {
        
        let profileData = {"signpFor": "client", "url":"/client/dashboard", "firstName": session['firstName'], "lastName": session['lastName'] }
        localStorage.setItem('userType', userType);
        return profileData

    } else {

        let userType = CORPORATE_LOGIN;
        let session = safeParseSession(userType)
        if(hasValidSession(session)) {
            
            let profileData = {"signpFor": "corporate", "url":"/corporate/dashboard", "firstName": session['firstName'], "lastName": session['lastName'], "business": session['business'] }
            localStorage.setItem('userType', userType);
            return profileData
        } else {
            
            let userType = PROVIDER_LOGIN;
            let urlfor = "";
            let session = safeParseSession(userType)
            if(hasValidSession(session)) {
                if(session['signupFor'] === "dealer") {
                    urlfor = "/dealer/dashboard"
                } else if(session['signupFor'] === "sales") {
                    urlfor = "/sales/dashboard"
                } else if(session['signupFor'] === "garage") {
                    urlfor = "/garage/dashboard"
                }
                let profileData = {"signupFor": session['signupFor'], "url":urlfor, "firstName": session['firstName'], "lastName": session['lastName'], "business": session['business'] }
                localStorage.setItem('userType', userType);
                return profileData
            } else {
                let profileData=false;
                return profileData
            }
        }
        
    }
}
  
export function getObject(key) {
    if (window && window.localStorage) {
        return window.localStorage.getItem(key);
    }
}

export function multiPartData(data, type='') {
    let multiPart = new FormData();
    for (let key in data) {
        
        if(key === 'imageGallery') {
            if (Array.isArray(data[key])) {
                data[key].forEach((file) => {
                    if (file instanceof File || file instanceof Blob) {
                        multiPart.append(key, file);
                    } else if (typeof file === 'string' && file.trim()) {
                        multiPart.append(key, file);
                    }
                });
            } else if (data[key] instanceof File || data[key] instanceof Blob) {
                multiPart.append(key, data[key]);
            } else if (typeof data[key] === 'string' && data[key].trim()) {
                multiPart.append(key, data[key]);
            }
       
        } else if(key !== 'imageGallery') {
            
            if(key === 'partType' || key === 'vehicleType' || key === 'offeredService' || key === 'serviceAvailable' || key === 'repairType' || key === 'nearService' || key === 'specialityService' || key === 'garageVehicleType' || key === 'salesVehicleType' || key === 'businessType' || key === 'serviceType') {
                multiPart.append(key, JSON.stringify(data[key]))
            } else if (key === 'isSold') {
                if (data[key] === true || data[key] === 'true' || data[key] === 1) {
                    multiPart.append(key, 'true');
                } else if (data[key] === false || data[key] === 'false' || data[key] === 0) {
                    multiPart.append(key, 'false');
                }
            } else {
                multiPart.append(key, data[key])
            }
        }
    }
  
    return multiPart
  }

export function formatVehicleMakeModel(v) {
    if (!v) return 'N/A';
    if (typeof v === 'string') return v;

    const item = Array.isArray(v) ? (v[0] || {}) : v;
    
    const vehObj = (item.vehicleData && typeof item.vehicleData === 'object')
        ? (Array.isArray(item.vehicleData) ? item.vehicleData[0] : item.vehicleData)
        : (item.vehicle && typeof item.vehicle === 'object' && !Array.isArray(item.vehicle) ? item.vehicle : item);

    const make = vehObj.make || item.make;
    const model = vehObj.model || item.model;
    const number = vehObj.vehicleNumber || item.vehicleNumber;
    const type = vehObj.type || item.type;
    const other = item.otherVehicle || vehObj.otherVehicle;

    const parts = [];
    if (number && number !== 'undefined' && number !== 'null') parts.push(number);
    if (make && make !== 'undefined' && make !== 'null') parts.push(make);
    if (model && model !== 'undefined' && model !== 'null') parts.push(model);
    if (type && type !== 'undefined' && type !== 'null') parts.push(type);

    if (parts.length > 0) return parts.join(' ');
    if (other && other !== 'undefined' && other !== 'null') return other;
    return 'N/A';
}

export function formatVehicleYear(v) {
    if (!v || typeof v === 'string') return '';

    const item = Array.isArray(v) ? (v[0] || {}) : v;
    const vehObj = (item.vehicleData && typeof item.vehicleData === 'object')
        ? (Array.isArray(item.vehicleData) ? item.vehicleData[0] : item.vehicleData)
        : (item.vehicle && typeof item.vehicle === 'object' && !Array.isArray(item.vehicle) ? item.vehicle : item);

    const year = vehObj.year || item.year || item.vehicleYear || vehObj.vehicleYear;
    return (year && year !== 'undefined' && year !== 'null') ? String(year) : '';
}

export function formatVehicleData(v) {
    if (!v) return 'N/A';
    if (typeof v === 'string') return v;

    const makeModel = formatVehicleMakeModel(v);
    const yr = formatVehicleYear(v);

    if (makeModel !== 'N/A' && yr) {
        return `${makeModel} (${yr})`;
    }
    return makeModel !== 'N/A' ? makeModel : (yr || 'N/A');
}

export function formatCleanAddress(data = {}) {
    if (!data) return 'N/A';
    if (typeof data === 'string') return data;

    const postalCode = (data.postalCode || '').trim();
    const rawAddress = (data.address || '').trim();

    if (rawAddress) {
        let clean = rawAddress;
        if (postalCode && clean.includes(postalCode)) {
            const idx = clean.indexOf(postalCode);
            clean = clean.substring(0, idx + postalCode.length);
        } else {
            clean = clean.replace(/,\s*Canada$/i, '');
        }
        return clean.trim();
    }

    const parts = [
        data.street ? (data.number ? `${data.number} ${data.street}` : data.street) : data.number,
        data.city,
        data.province,
        postalCode
    ].filter(Boolean);

    return parts.length ? parts.join(', ') : 'N/A';
}

export function resolveImageUrl(imagePath) {
    if (!imagePath) {
        return '';
    }
    if (Array.isArray(imagePath)) {
        imagePath = imagePath.find(item => typeof item === 'string') || '';
    }
    if (typeof imagePath !== 'string') {
        return '';
    }

    if (imagePath.startsWith('data:') || imagePath.startsWith('blob:') || imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    const baseUrl = (url || "http://localhost:3001/api/").replace('/api/', '/').replace(/\/+$/, '');
    return `${baseUrl}/${imagePath.replace(/^\/+/, '')}`;
}

export function formatVehicleDisplayLabel(vehicleData = {}) {
    if (!vehicleData) return '';
    const num = vehicleData.vehicleNumber || vehicleData.fileNumber || '';
    const cleanNum = (num && !num.startsWith('Insurance-') && !num.startsWith('Gov-')) ? num : '';
    const parts = [
        cleanNum,
        vehicleData.model,
        vehicleData.make,
        vehicleData.year,
        vehicleData.type
    ].filter(Boolean);
    return parts.join(' ').trim();
}
